export var ICON_PREFIX = 'acuicon';
export var DEFAULT_WIDTH = '16px';
